import {Chip} from "@mui/material";
import React from "react";


const StationFeatureChip = ({feature, onDelete}) => {
    {
        let s = ""
        if (feature.properties.name) {
            s = `${feature.properties.name} (${feature.properties.code})`
        } else {
            s = `${feature.properties.code}`
        }
        return <Chip label={s}
                     size="small"
                     color="primary"
                     onDelete={onDelete}/>
    }
}


export default StationFeatureChip;